// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from "../../../types";

import gql from "graphql-tag";
import {
  InProgressBookingProposalFragmentDoc,
  InProgressBookingEventFragmentDoc,
} from "./InProgressBooking/InProgressBooking.generated-types";
import { ConfirmedBookingEventFragmentDoc } from "./ConfirmedBooking/ConfirmedBooking.generated-types";
import { GetStatusesEventFragmentDoc } from "../../../Graphql-Utilities/getStatuses/getStatuses.generated-types";
import { WithdrawBriefEventFragmentDoc } from "./WithdrawBrief/WithdrawBrief.generated-types";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type BookingEventQueryVariables = Types.Exact<{
  UUID: Types.Scalars["ID"];
}>;

export type BookingEventQuery = {
  __typename?: "Query";
  getEventByUUID: {
    __typename?: "Event";
    UUID: string;
    name: string;
    currency: string;
    fromDateTime: string;
    toDateTime: string;
    submittedAt: string;
    proposalCount: number;
    status: Types.EventStatus;
    budget: number;
    attendees: number;
    location: string;
    cateringNeeds?: string | null;
    additionalNotes?: string | null;
    layoutID: string;
    proposals: Array<{
      __typename?: "Proposal";
      status: Types.ProposalStatus;
      UUID: string;
      invitationID: number;
      baseCostTotal: number;
      ID: number;
      currency: string;
      baseCostDescription: string;
      message?: string | null;
      hasPreferredVenue: boolean;
      space: {
        __typename?: "SelfServeSpace";
        spaceName?: string | null;
        description?: string | null;
        spacePhotos?: Array<{
          __typename?: "SelfServeSpacePhoto";
          url?: string | null;
        }> | null;
        venue?: {
          __typename?: "SelfServeVenue";
          name?: string | null;
          addressLine1?: string | null;
          city?: string | null;
          postalCode?: string | null;
          nearestTransit?: {
            __typename?: "NearestTransit";
            station?: string | null;
          } | null;
        } | null;
        hostContact: {
          __typename?: "HostContact";
          email?: string | null;
          phoneNumber?: string | null;
        };
        spaceFeatures?: Array<{
          __typename?: "SelfServeSpaceFeature";
          ID?: number | null;
          name?: string | null;
        }> | null;
        spatialConfigurations?: Array<{
          __typename?: "SelfServeSpatialConfiguration";
          name?: string | null;
          capacity?: number | null;
        }> | null;
      };
      documents?: Array<{
        __typename?: "ProposalDocument";
        filename: string;
        URL: string;
        ID: number;
      }> | null;
      extraCostItems?: Array<{
        __typename?: "ExtraCostItem";
        ID: number;
        description: string;
        quantity?: number | null;
        costPerUnit: number;
      }> | null;
    }>;
    invitations?: Array<{
      __typename?: "Invitation";
      ID: number;
      declinedAt?: string | null;
    }> | null;
    spaceFacilities?: Array<{
      __typename?: "SpaceFacility";
      id: number;
      name: string;
    }> | null;
  };
};

export const BookingEventDocument = gql`
  query BookingEvent($UUID: ID!) {
    getEventByUUID(UUID: $UUID) {
      UUID
      proposals {
        status
        ...InProgressBookingProposal
      }
      ...ConfirmedBookingEvent
      ...InProgressBookingEvent
      ...WithdrawBriefEvent
      ...GetStatusesEvent
    }
  }
  ${InProgressBookingProposalFragmentDoc}
  ${ConfirmedBookingEventFragmentDoc}
  ${InProgressBookingEventFragmentDoc}
  ${WithdrawBriefEventFragmentDoc}
  ${GetStatusesEventFragmentDoc}
`;

export function useBookingEventQuery(
  options: Omit<Urql.UseQueryArgs<BookingEventQueryVariables>, "query">
) {
  return Urql.useQuery<BookingEventQuery>({
    query: BookingEventDocument,
    ...options,
  });
}
